import { ActionStatus, ActionType, useGetActionsQuery, useIsCardTermsSignedQuery } from '../graphql'
import { PATH_PARAMS } from '../routes/paths'
import { useParams } from 'react-router-dom'
import { useMemo } from 'react'
import { head } from 'lodash'

export const useTermAndConditionsSignCheck = () => {
  const { [PATH_PARAMS.applicationId]: applicationId } = useParams() as Record<string, string>

  const { data: actionData } = useGetActionsQuery({
    variables: {
      contractId: applicationId,
      types: [ActionType.TermsAndConditionsSigning],
    },
    fetchPolicy: 'network-only',
  })

  const { data: cardTermsData } = useIsCardTermsSignedQuery({
    variables: {
      contractId: applicationId,
    },
  })

  const firstNonRejectedAction = useMemo(() => {
    const nonRejectedActions = actionData?.actions?.filter(
      (action) => action?.status !== ActionStatus.Rejected,
    )
    return head(nonRejectedActions)
  }, [actionData])

  return {
    isTermsAndConditionsSigned: cardTermsData?.isProductTermsSignedOrPending ?? false,
    termsAndConditionActionDetails: {
      id: firstNonRejectedAction?.id,
      actionStatus: firstNonRejectedAction?.status,
    },
  }
}
